/**
 * Product access mode for Broader Business.
 * waitlist-only: public marketing + waitlist capture only.
 * No login, sessions, dashboard, or product surfaces.
 */
export const WAITLIST_ONLY = true;

/** Public marketing nav items allowed while waitlist-only. */
export const PUBLIC_NAV_ITEMS = new Set([
  'overview',
  'how-it-works',
  'pricing',
  'faq',
  'privacy',
  'terms',
]);

/** Auth / product token keys that must never grant access in waitlist mode. */
export const AUTH_STORAGE_KEYS = [
  'google_tokens',
  'facebook_tokens',
  'instagram_tokens',
  'email_tokens',
  'twitter_tokens',
  'linkedin_tokens',
  'shopify_tokens',
  'google_oauth_state',
  'facebook_oauth_state',
  'facebook_access_token',
  'twitter_code_verifier',
  'linkedin_oauth_state',
  'shopify_oauth_state',
  'shopify_shop_name',
];

export const WAITLIST_STORAGE_KEY = 'bb_waitlist_emails';
